import { render, staticRenderFns } from "./Longtext.vue?vue&type=template&id=38dd421d&scoped=true&"
import script from "./Longtext.vue?vue&type=script&lang=js&"
export * from "./Longtext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd421d",
  null
  
)

export default component.exports